<template>
    <form class="form-horizontal" @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-lg-12 mb-3">
                <div class="row">
                    <label class="col-md-3 col-form-label">User ID</label>
                    <div class="col-md-8">
                        <p class="m-0 mt-2">{{ user.id }}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-md-3 col-form-label">Email*</label>
                    <div class="col-md-8">
                        <fg-input
                            v-model="form.email"
                            v-validate="modelValidations.email"
                            :error="getError('email')"
                            name="email"
                            autoComplete="off"
                            type="email"
                        >
                        </fg-input>
                    </div>
                </div>
                <div v-if="user.email !== form.email" class="row">
                    <label class="col-md-3 col-form-label">Enter Password*</label>
                    <div class="col-md-8">
                        <p class="hint mb-1 mt-2">
                            You must re-enter your password to change your email.
                        </p>
                        <fg-input
                            v-model="form.password"
                            v-validate="modelValidations.password"
                            :error="getError('password')"
                            name="password"
                            autoComplete="off"
                            type="password"
                        >
                        </fg-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-md-3 col-form-label">First Name</label>
                    <div class="col-md-8">
                        <fg-input
                            v-model="form.firstName"
                            v-validate="modelValidations.firstName"
                            :error="getError('firstName')"
                            name="firstName"
                            autoComplete="off"
                            type="text"
                        >
                        </fg-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-md-3 col-form-label">Last Name</label>
                    <div class="col-md-8">
                        <fg-input
                            v-model="form.lastName"
                            v-validate="modelValidations.lastName"
                            :error="getError('lastName')"
                            name="firstName"
                            autoComplete="off"
                            type="text"
                        >
                        </fg-input>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="row">
            <label class="col-md-3 col-form-label"></label>
            <div class="col-md-3">
                <p-button slot="footer" :disabled="loading" nativeType="submit" type="primary" block class="mb-3">
                    <i v-if="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    {{ loading ? null : 'Submit' }}
                </p-button>
            </div>
        </div>
    </form>
</template>
<script>
import { USERS_SUPPORT } from 'db'
import { Validator } from 'vee-validate'
import { clearFields } from '@/utils'
import { getError } from '@/utils/validateErrors'
import { Checkbox, Button } from '@/components/UIComponents'
export default {
    components: {
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
    },
    props: {
        loading: Boolean,
        user: {
            type: [Object, Boolean],
            default: false
        },
        shouldClear: Boolean,
        title: {
            type: String,
            default: ''
        },
        hint: {
            type: String,
            default: ''
        },
        editing: Boolean
    },
    data() {
        return {
            form: {
                email: this.user ? this.user[USERS_SUPPORT.fields.email] : '',
                firstName: this.user ? this.user[USERS_SUPPORT.fields.firstName] : '',
                lastName: this.user ? this.user[USERS_SUPPORT.fields.lastName] : '',
                password: ''
            },
            modelValidations: {
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true
                }
            }
        }
    },
    created() {
        const dictionary = {
            en: {
                attributes: {
                    email: 'email',
                    firstName: 'first name',
                    lastName: 'last name'
                }
            }
        }
        Validator.localize(dictionary)
    },
    methods: {
        getError,
        async handleSubmit() {
            const isValid = await this.$validator.validateAll()
            if (isValid) {
                const values = {
                    email: this.form.email,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    password: this.form.password
                }
                this.$emit('submit', values)
                this.form.password = ''
                if (this.shouldClear) {
                    this.form = clearFields(this.form)
                    this.$validator.reset()
                }
            }
        }
    }
}
</script>
